export default {
    methods: {
        $route () {
            if (route === undefined) return '#'
            return route(...arguments)
        },
        $goto () {
            location.href = this.$route(...arguments)
        },
        $openWindow(){
            window.open(this.$route(...arguments), "_blank");
        }
    },
}
